"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-zeno-di-montagna": {
    "castello": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e753ec78": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "skipSearch": false
    }],
    "borno": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "47ad6af4": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "skipSearch": false
    }],
    "ca-longa": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4274227a": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "skipSearch": false
    }],
    "ca-montagna": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "db177f99": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "skipSearch": false
    }],
    "ca-sartori": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f34d8a7b": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "skipSearch": false
    }],
    "ca-schena": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "04eed414": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "skipSearch": false
    }],
    "canevoi": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aeb79623": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "skipSearch": false
    }],
    "ec9b9144": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "skipSearch": false
    }],
    "la-ca": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8d68e05d": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "skipSearch": false
    }],
    "la-pora": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "feabec27": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "skipSearch": false
    }],
    "laguna": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5b55d32e": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "skipSearch": false
    }],
    "le-tese": [{
      "hkey": "b16d794c",
      "slug": "san-zeno-di-montagna",
      "name": "San Zeno di Montagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;